import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderGuestComponent } from './components/theme/_guest/header/header.component';
import { FooterGuestComponent } from './components/theme/_guest/footer/footer.component';
import { MainGuestComponent } from './components/theme/_guest/main/main.component';
import { MenuGuestComponent } from './components/theme/_guest/menu/menu.component';
import { MainPageComponent } from './components/theme/_guest/main-page/main-page.component';
import { SwitchTabDirective } from './directives/switch-tab.directive';
import { NotThaiCharDirective } from './directives/not-thai-char.directive';
import { IntegerOnlyDirective } from './directives/integer-only.directive';
import { EnglishUpperCaseOnlyDirective } from './directives/english-uppercase-only.directive';
import { MobileFormatDirective } from './directives/mobile-format.directive';
import { NgxSelectModule } from 'ngx-select-ex';
import { Demical2Pipe } from './pipe/demical2.pipe'; 
import { ToggleDirective } from './directives/toggle.directive';
import { ThaiDatePipe } from './directives/thaidate.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from '@angular/material/core';
import { MaterialModule } from '../material';
import { MaskDirective } from './directives/mark.directive';
import { IDCardPipe } from './pipe/idcard-pipe';
import { BehindIDCardPipe } from './pipe/behind-idcard-pipe';
import { phonePipe } from './pipe/phone-pipe';

import {MatCardModule} from '@angular/material/card'; 
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import {MatButtonModule} from '@angular/material/button';
import { ToggleValidateDirective } from './directives/toggle-validate.directive';
import { UsernameDirective } from './directives/username.directive';
import { PasswordDirective } from './directives/password.directive';
import { EnterTextareaDirective } from './directives/enter-textarea.directive'; 
import { QRCodeModule } from 'angularx-qrcode';
import { CopyPasteBlockDirective } from './directives/captcha.directive';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CourtEmergencyCallComponent } from '../features/user/shared-user/court-emergency-call/court-emergency-call.component';
import { KeepHtmlPipe } from './pipe/keep-html.pipe';

import { AutosizeModule } from 'ngx-autosize';
import { GrdFilterPipe } from './pipe/grid-table-filter.pipe';
import { ModalNotificationComponent } from './components/modal-notification/modal-notification.component';

@NgModule({
  // providers:[
  //   { provide: LOCALE_ID, useValue: "th-TH" }
  // ],
  declarations: [ 
    PageLoaderComponent,
    PaginatorComponent,
    MainGuestComponent,
    HeaderGuestComponent,
    FooterGuestComponent,
    MenuGuestComponent,
    MainPageComponent,
    SwitchTabDirective,
    NotThaiCharDirective,
    IntegerOnlyDirective,
    EnglishUpperCaseOnlyDirective,
    MobileFormatDirective,
    Demical2Pipe, 
    ToggleDirective,
    ToggleValidateDirective,
    ThaiDatePipe,
    MaskDirective,
    IDCardPipe,
    BehindIDCardPipe,
    phonePipe,
    UsernameDirective,
    PasswordDirective,
    EnterTextareaDirective,
    CopyPasteBlockDirective,
    CourtEmergencyCallComponent,
    KeepHtmlPipe,
    GrdFilterPipe,
    ModalNotificationComponent,
    PaginatorComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgbModalModule,
    NgxPermissionsModule,
    RouterModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    NgxSelectModule,
    MaterialModule, 
    MatToolbarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatPasswordStrengthModule,
    QRCodeModule,
    NgxExtendedPdfViewerModule,
    AutosizeModule
  ],
  exports: [ 
    PageLoaderComponent,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgbModalModule,
    NgxPermissionsModule,
    MainGuestComponent,
    HeaderGuestComponent,
    FooterGuestComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    SwitchTabDirective,
    NotThaiCharDirective,
    IntegerOnlyDirective,
    EnglishUpperCaseOnlyDirective,
    MobileFormatDirective,
    NgxSelectModule,
    Demical2Pipe,
    ToggleDirective,
    ToggleValidateDirective,
    ThaiDatePipe,
    MaskDirective,
    IDCardPipe,
    BehindIDCardPipe,
    phonePipe,
    EnterTextareaDirective,

    MaterialModule,
    MatToolbarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatPasswordStrengthModule,
    UsernameDirective,
    PasswordDirective,
    QRCodeModule,
    CopyPasteBlockDirective,
    NgxExtendedPdfViewerModule,
    CourtEmergencyCallComponent,
    KeepHtmlPipe,
    AutosizeModule,
    GrdFilterPipe,
    ModalNotificationComponent,
    PaginatorComponent
  ]
})
export class SharedModule { }
